import { detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { IntroOutroViewBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";


export class IntroOutroViewGame extends IntroOutroViewBehavior {

    protected resize(evt?: any): void {
        super.resize(evt);
        this.resizeElements();
        if ((!ingenuity.deviceEnv.isDesktop) && ( ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT)) {
            ingenuity.currentGame.stage.addChild(this);
            dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
        }
    }
     private resizeElements():void{
        let introPopupBG = this.getShapeById('introPopupBG');
        let outroPopupBG = this.getShapeById('outroPopupBG');
            if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
            introPopupBG.scale.y = 2;
            introPopupBG.y = -337;
            outroPopupBG.scale.y = 2;
            outroPopupBG.x = -360;
            outroPopupBG.y = -640;
            } else {
            introPopupBG.scale.x = 1;
            introPopupBG.y = 0;
            outroPopupBG.scale.y = 1;
            outroPopupBG.x = 0;
            outroPopupBG.y = 0;
            }
        }
       protected scaleComponents() {
                const heightScale = innerHeight / ingenuity.configData.height;
                const widthScale = innerWidth / ingenuity.configData.width;
                if (this.introTextContainer) {
                    if (widthScale < heightScale) {
                        const finalScale = widthScale / heightScale;
                        this.introTextContainer.scale.set(finalScale);
                    }
                    else {
                        this.introTextContainer.scale.set(1);
                    }
                }
                if (this.outroTextContainer) {
                    if (widthScale < heightScale) {
                        const finalScale = widthScale / heightScale;
                        this.outroTextContainer.scale.set(finalScale);
                    }
                    else {
                        this.outroTextContainer.scale.set(1);
                    }
                }
            }
}